
import Vue, { PropType } from 'vue';

import Table from '@/components/common/Table.vue';
import ConfirmActionModal from '@/components/modal/ConfirmActionModal.vue';
import { BvTableFieldArray } from 'bootstrap-vue/src/components/table';
import { DeviceType } from '@/interfaces/types';
import { DeviceRow } from '@/views/configuration/DeviceListView.vue';

export default Vue.extend({
	name: 'SiteSensorList',

	components: {
		Table,
		ConfirmActionModal,
	},

	data(): {
		sensorCategory: string | null;
		sensorName: string | null;
		controllerName: string | null;
		sensorId: number | null;
		controllerId: number | null;
	} {
		return {
			sensorCategory: null,
			sensorName: null,
			controllerName: null,
			sensorId: null,
			controllerId: null,
		};
	},

	computed: {
		fields(): BvTableFieldArray {
			return [
				{
					key: 'name',
					label: this.$i18n.t('Name').toString(),
					sortable: true,
					thClass: 'name-column-width',
					tdClass: 'name-column-width',
				},
				{
					key: 'type',
					label: this.$i18n.t('Type').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'floor',
					label: this.$i18n.t('Floor').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'room',
					label: this.$i18n.t('Room').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'zone',
					label: this.$i18n.t('Zone').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'controllerVersion',
					label: this.$i18n.t('Version').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'channel',
					label: this.$i18n.t('Channel').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{ key: 'identify', label: this.$i18n.t('Identify').toString(), sortable: false },
				{
					key: 'appliedRule',
					label: this.$i18n.t('Rule').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{ key: 'delete', label: '', thClass: 'outline-disable' },
			];
		},
	},

	props: {
		sensors: {
			type: Array as PropType<DeviceRow[]>,
			default: (): DeviceRow[] => [],
		},
		userPermission: { type: Boolean, default: true },
		deviceTypes: { type: Array as PropType<DeviceType[]>, default: (): DeviceType[] => [] },
		hasIdentifyRule: { type: Boolean, default: true },
	},

	methods: {
		onModifySensor(row: DeviceRow): void {
			this.$emit('deviceClicked', row);
		},

		changeIdentify(row: DeviceRow): void {
			this.$emit('changeIdentify', row.id, row.identify);
		},

		confirmSensorDeletion(row: DeviceRow): void {
			this.sensorCategory = row.category;
			this.sensorName = row.name;
			this.controllerName = row.controllerName;
			this.sensorId = row.id;
			this.controllerId = row.controllerId;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$refs.devicesDeletionConfirmModal as any).show();
		},

		removeSelectedSensor(): void {
			this.sensorCategory = null;
			this.sensorName = null;
			this.controllerName = null;
			this.sensorId = null;
			this.controllerId = null;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$refs.devicesDeletionConfirmModal as any).hide();
		},

		deleteSensor(): void {
			switch (this.sensorCategory) {
				case 'sensors':
					this.$emit(
						'removeSensor',
						{
							selectedDeviceId: this.sensorId,
							selectedControllerId: this.controllerId,
							selectedCategory: 'luminaires',
						},
						'deleteLuminaire'
					);
					break;

				case 'switches':
					this.$emit(
						'removeSensor',
						{
							selectedDeviceId: this.sensorId,
							selectedControllerId: this.controllerId,
							selectedCategory: this.sensorCategory,
						},
						'deleteSwitch'
					);
			}
			this.removeSelectedSensor();
		},
	},
});
